module.exports = __webpack_public_path__ + "img/04.abf87710.jpg";